<template>
  <ClientOnly>
    <div class="swiper">
      <div class="grid-row row row-cols-1 row-cols-sm-2 row-cols-lg-4 swiper-wrapper">
        <div class="col swiper-slide" v-for="(product,index) of products" :key="`prod`+index">
          <ProductCard :product="product" v-if="product!=null"/>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<script>
import { isServer } from "@storefront/core/helpers";
import ClientOnly from "vue-client-only";

import { mapActions } from "vuex";
import ProductCard from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductCard.vue";

export default {
  name: "MoreProductsCarousel",
  components: {
    ClientOnly,
    ProductCard,
  },
  props: {
    products: { type: Array },
  },
  mounted() {
    if (!isServer) {
      window.addEventListener("resize", this.setNoOfSlidePerPage);
      window.addEventListener("load", this.setNoOfSlidePerPage);
      this.setNoOfSlidePerPage();
    }
  },
  destroyed() {
    if (!isServer) {
      window.removeEventListener("resize", this.setNoOfSlidePerPage);
      window.removeEventListener("load", this.setNoOfSlidePerPage);
    }
  },
  data() {
    return {
      slidePerPage: this.setNoOfSlidePerPage(),
      autoplay: false
    };
  },
  methods: {
    ...mapActions(["setProductStatus"]),
    setNoOfSlidePerPage() {
      if (isServer) {
        this.slidePerPage = 4;
      } else {
        if (window.innerWidth < 768) {
          this.slidePerPage = 1;
          this.autoplay = true;
        } else if (window.innerWidth > 767 && window.innerWidth < 992) {
          this.slidePerPage = 3;
        } else {
          this.slidePerPage = 4;
        }
      }
    },
    toggleWishListStatus(productId) {
      this.setProductStatus({ productId });
    },
  },
};
</script>

